import {createActions} from 'redux-actions';
import _ from 'lodash';

import constants from '@constants';
import api from '@api';
import utils from '@utils';

const actions = createActions({
  getOneUser: async (id: string, isOnlyAdmin?: boolean) => {
    const detail = await api.users.getOne(id);
    // 存在しないユーザーを指定された場合、nullが返って来るため、Errorをthrow
    if (_.isNull(detail)) {
      throw new Error(constants.ERRORS.USER_NOT_FOUND);
    } else {
      return {detail, isOnlyAdmin};
    }
  },

  getUserDetail: async (id: string, users: any[]) => {
    let detail = _.find(users, {id: Number(id)});

    if (_.isUndefined(detail)) {
      detail = await api.users.getOne(id);
    }

    return {detail};
  },

  clearUserDetail: () => {
    return {
      id: 0,
      sub: '',
      lastName: '',
      firstName: '',
      lastKana: '',
      firstKana: '',
      email: '',
      phoneNumber: '',
      prefecture: 0,
      authLevel: 0,
    };
  },

  createUser: async (requestBody: UserCreateBody) => {
    const user = await api.users.create(requestBody);

    return user;
  },

  updateUser: async (
    requestBody: UserUpdateBody,
    id: string,
    isMyPage?: boolean
  ) => {
    const detail = await api.users.update(requestBody, id);

    if (isMyPage) {
      detail.authLevel = 0;
      return {detail};
    }
    return {detail};
  },

  deleteUser: async (id: string) => {
    try {
      await api.users.destroy(id);

      return;
    } catch (error) {
      throw new Error(error);
    }
  },

  updateSearchWordsUsers: async (keywords: UsersStore['search']) => {
    try {
      const res = await api.users.paging({
        ...keywords,
        page: 1,
        sort: keywords.sort,
        teamId: keywords.teamId,
      });
      const pagination: PaginationActionOutput = {
        data: res.data.pages,
        totalCount: res.headers['x-total-count']
          ? Number(res.headers['x-total-count'])
          : 0,
        totalPages: res.headers['x-total-pages']
          ? Number(res.headers['x-total-pages'])
          : 0,
        current: 1,
        sort: keywords.sort,
      };

      return {pagination, keywords};
    } catch (err) {
      throw new Error(err);
    }
  },

  clearSearchWords: () => {
    return {
      name: [],
      prefecture: null,
      email: [],
    };
  },

  updateActiveUsers: (
    pages: any,
    current: number,
    nextCurrent: number,
    totalPages: number
  ) => {
    const active = utils.pagination.makeRemoteActive(
      pages,
      current,
      nextCurrent,
      totalPages
    );

    return {active, nextCurrent};
  },

  updateCurrentUsers: async (input: PaginationActionInput) => {
    try {
      const res = await api.users.paging(input);

      const pagination: PaginationActionOutput = {
        data: res.data.pages,
        totalCount: res.headers['x-total-count']
          ? Number(res.headers['x-total-count'])
          : 0,
        totalPages: res.headers['x-total-pages']
          ? Number(res.headers['x-total-pages'])
          : 0,
        current: input.page,
        sort: input.sort,
      };

      return pagination;
    } catch (err) {
      throw new Error(err);
    }
  },
  clearTableSort: () => {
    return {
      sort: '-createdAt',
    };
  },
});

export default actions;
